export default "__VITE_ASSET__e3hvi6Ia__"